import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  unread_notification: 0,
  notificationList: {
    data: {
      new: [],
      earlier: []
    },
    offset: 0,
    limit: 10,
    hasMore: true,
    isLoading: false
  },
  deleteNotificationSuccess: false
};

export default function notificationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Count
    case actionTypes.GET_NOTIFICATION_COUNT:
    case actionTypes.GET_NOTIFICATION_COUNT_FAIL:
      return {
        ...state,
        unread_notification: 0
      };
    case actionTypes.GET_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        unread_notification: action.data
      };

    // Load
    case actionTypes.LOAD_NOTIFICATION_LIST: {
      let notificationList = cloneDeep(state.notificationList);
      notificationList.offset = action.data.offset;
      notificationList.limit = action.data.limit;
      notificationList.isLoading = true;

      if (action.data.offset === 0) {
        notificationList.data = { new: [], earlier: [] };
      }

      return {
        ...state,
        notificationList
      };
    }

    case actionTypes.LOAD_NOTIFICATION_LIST_SUCCESS: {
      let notificationList = cloneDeep(state.notificationList);
      let data = action.data;

      notificationList.data.new = [...notificationList.data.new, ...data.new];
      notificationList.data.earlier = [
        ...notificationList.data.earlier,
        ...data.earlier
      ];
      notificationList.isLoading = false;
      notificationList.hasMore = true;

      if (data.new.length === 0 && data.earlier.length === 0) {
        notificationList.hasMore = false;
      }
      return {
        ...state,
        notificationList
      };
    }

    case actionTypes.LOAD_NOTIFICATION_LIST_FAIL: {
      let notificationList = cloneDeep(state.notificationList);

      notificationList.isLoading = false;
      notificationList.hasMore = false;

      return {
        ...state,
        notificationList
      };
    }

    // Delete
    case actionTypes.DELETE_NOTIFICATION:
    case actionTypes.DELETE_NOTIFICATION_FAIL: {
      return {
        ...state,
        deleteNotificationSuccess: false
      };
    }
    case actionTypes.DELETE_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        deleteNotificationSuccess: true
      };
    }

    default:
      return state;
  }
}
